import { useEffect, useState } from 'react';
import { SetupByKeyFetch } from '@/api/setup';

const useVerifySMSConfirmationIsOn = (ddd: string, isPortability: boolean) => {
  const { data: setup } = SetupByKeyFetch('DDDS_TOKEN_VALIDATION');

  const gatsbySmsConfirmationOn = import.meta.env.VITE_SMS_CONFIRMATION_ON;

  const [isSMSConfirmationOn, setIsSMSConfirmationOn] = useState(false);

  useEffect(() => {
    const areaCodeTokenValidation = setup?.valor.split(',');

    const foundDdd = areaCodeTokenValidation?.find(
      (areaCode) => areaCode === ddd,
    );

    const checkIsSMSConfirmationOn =
      !foundDdd && isPortability && gatsbySmsConfirmationOn === 'true';

    setIsSMSConfirmationOn(checkIsSMSConfirmationOn);
  }, [ddd, isPortability, gatsbySmsConfirmationOn, setup]);

  return isSMSConfirmationOn;
};

export default useVerifySMSConfirmationIsOn;
